import dayjs, { Dayjs } from 'dayjs';

export function isEmptyProductRow(
  product: { code?: string; productId?: number; name?: string } | null | undefined,
): boolean {
  if (!product) {
    return true;
  }
  return !product.code && !product.productId && !product.name;
}

export function getFilledProducts<T extends { code?: string; productId?: number; name?: string }>(
  products: T[] | undefined,
): T[] {
  return (products || []).filter(product => !isEmptyProductRow(product));
}

export function hasAtLeastOneProduct(
  products: { code?: string; productId?: number; name?: string }[] | undefined,
): boolean {
  return getFilledProducts(products).length >= 1;
}

export function calculateVATAmount(amount: number, vat: number): number {
  let delta = 100;
  if (vat < 1) {
    delta = 1;
  }
  return ((amount * vat) / (delta + vat)) | 0;
}

/** Format dayjs as local calendar date YYYY-MM-DD for API (avoids UTC shift in GMT+7). */
export function formatLocalDate(d: Dayjs): string {
  return `${d.year()}-${String(d.month() + 1).padStart(2, '0')}-${String(d.date()).padStart(2, '0')}`;
}

/** Parse server date (UTC or date-only) to local midnight Dayjs for form/DatePicker. */
export function parseServerDateToLocal(serverDate: string): Dayjs {
  const parsed = dayjs(serverDate);
  return parsed.isValid() ? dayjs(parsed.format('YYYY-MM-DD')) : dayjs(serverDate);
}

export function formatNumberWithCommas(value: number): string {
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function formatCurrency(value: number): string {
  if (!value) {
    return `${value} đ`;
  }
  return `${value.toLocaleString('vi-VN')} đ`;
}
